import React from 'react';
import { animated } from 'react-spring';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { ReactComponent as ShoppingIcon } from '../../../../../assets/icon/trash.svg';
import { formatPriceItem } from '../../../../../utils';
import { useTranslation } from 'react-i18next';

interface FloatingCartProps {
  animation: any;
  totalCount: number;
  totalPrice: number;
  onDelivery: () => void;
}

const FloatingCart: React.FC<FloatingCartProps> = ({ animation, totalCount, totalPrice, onDelivery }) => {
  const { t } = useTranslation();

  return (
    <animated.div
      style={animation}
      className="fixed flex z-50 gap-1 justify-between items-center bottom-20 left-1/2 w-[calc(100%-2rem)] sm:max-w-[93%] max-w-[640px] bg-white py-2 px-3 rounded-[1000px] border border-green-200"
    >
      <div className="flex gap-2 items-center w-[65%]">
        <ShoppingIcon className="w-6 h-6" />
        <div className="not-italic">
          <p className="text-green-700 font-semibold text-sm leading-5">
            {totalCount} {t('MENU_CARD_ITEMS')}
          </p>
          <p className="text-gray-500 text-[10px] font-normal leading-[18px] truncate max-w-[150px]">
            {t('ORDER_STATUS_TITLE')}
          </p>
        </div>
      </div>
      <button onClick={onDelivery} className="rounded-[1000px] w-max flex items-center bg-green-500 text-white text-sm pl-3 pr-2 py-2">
        <span className="whitespace-nowrap">¥ {formatPriceItem(totalPrice)}</span>
        <KeyboardArrowRightIcon className="text-gray-200" />
      </button>
    </animated.div>
  );
};

export default FloatingCart;
